<template>
    <div class="my-test">
        <div class="user-title clearfix">
            <div class="fl">我的服务</div>
            <div class="fr">
                <el-button type="success" plain @click="member" v-if="list.is_vip==false">成为会员</el-button>
            </div>
        </div>
        <div class="content">
            <template>
                <el-table
                :data="list.list"
                style="width: 100%">
                <el-table-column
                    prop="title"
                    label="服务名称"
                    width="300"
                    align='center'>
                </el-table-column>
                <el-table-column
                    prop="addtime"
                    label="时间"
                    width="300"
                    align='center'>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align='center'>
                    <template slot-scope="scope" v-if="scope.row.type==1">
                       <el-button type="text" @click="operation('查看',scope.row.qrid)">查看</el-button>
                       <el-button type="text" @click="operation('删除',scope.row.qrid,scope.row.type)">删除</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </template>
        </div>
    </div>
</template>

<script>
import { TestQuestionList } from "../../api/api";
import { DelTestQuestion } from "../../api/api";

export default {
 data(){
     return{
         list:[]
     }
 },
 created(){
     this.getList();
 },
 methods:{
     member(){ //成为会员
       this.$router.push({name:'userPrice'});
     },
     getList(){
        this.$axios.post(TestQuestionList, {}).then(
        res => {
            if (res.data.code == 1) {
            this.list = res.data.data;
            } else {
            this.list = [];
            }
        },
        err => {
            this.list = [];
        }
        );
     },
     operation(btnName,qrid,type){
        if(btnName=='查看'){
          this.$router.push({name:'userMyTestResult',query:{qrid:qrid}});
        }else{
           this.$confirm('是否删除该测试记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            var db={
                qrid:qrid,
                type:type
            }
          this.$axios.post(DelTestQuestion, db).then(
             res => {
                if (res.data.code == 1) {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.getList();
                } else {
                   this.$message.error(res.data.msg);
                }
            },
            err => {
                this.$message.error(err.data.msg);
            }
            );
        }).catch(() => {         
        });
        }
     },
 }
}
</script>

<style>

</style>
